import React from 'react';
import * as qs from 'query-string';
import {
  Container,
  Row,
  Col,
  CardGroup,
  Card,
  CardBody
} from 'reactstrap';

import PasswordReset from '../../views/Pages/PasswordReset';
import VerifyEmail from '../../views/Pages/VerifyEmail';

// http://localhost:3000/userMgmt?mode=resetPassword&oobCode=ABC123&apiKey=AIzaSy

// mode - The user management action to be completed
// oobCode - A one-time code, used to identify and verify a request
// apiKey - Your Firebase project's API key, provided for convenience

const UserManagement = (props) => {
  const parsedSearch = qs.parse(props.location.search)
  // Get the action to complete.
  const mode = parsedSearch.mode;
  // Get the one-time code from the query parameter.
  const actionCode = parsedSearch.oobCode;

  // (Optional) Get the API key from the query parameter.
  // const apiKey = props.location.query.apiKey;

  // Handle the user management action.
  switch (mode) {
    case 'recoverEmail':
      // Display reset password handler and UI.
      // return <RecoverEmail actionCode={actionCode} />;
      console.log("recoverEmail - Not supported as of now.");
    case 'resetPassword':
      // Display email recovery handler and UI.
      console.log("Resetting password")
      return <PasswordReset actionCode={actionCode} />;
    case 'verifyEmail':
      // Display email verification handler and UI.
      console.log("Verifying email")
      return <VerifyEmail actionCode={actionCode} />;
    default:
      // Error: invalid mode.
      return (
        <div className="app flex-row align-items-center">
          <Container>
            <Row className="justify-content-center">
              <Col md="8">
                <CardGroup>
                  <Card className="p-4">
                    <CardBody>
                      <h1>THE CRICKET SCOREBOOK</h1>
                      <p>Invalid user management option. Check the URL.</p>
                    </CardBody>
                  </Card>
                </CardGroup>
              </Col>
            </Row>
          </Container>
        </div>
      );
    }
}

export default UserManagement;



// WEBPACK FOOTER //
// ./src/components/UserManagement/UserManagement.js